import React, { memo } from 'react';
import { BTN_BACK_HIDDEN } from '../../utils/Constants';
import './styles.css';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import icBack from '../../assets/imgs/ic_btn_back.svg?react';
import icRefetch from '../../assets/imgs/ic_refetch.svg?react';
import { isReactNativeWebView, sendMessageToNativeApp } from '../../utils/reactNativeUtils';

/**
 * ヘッダのComponent
 */
type HeaderProps = {
    title?: string | null;
    redirect?: string;
    refetch?: () => void;
    callback?: () => void;
};

const Header: React.FC<HeaderProps> = memo(({ title, redirect, refetch, callback }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isBtBack = BTN_BACK_HIDDEN.includes(location.pathname);

    /**
     * 戻るボタンの処理
     *
     * @returns {void}
     */
    const handleBackButton = () => {
        if (typeof callback === 'function') {
            callback();
            return;
        }
        //リダイレクトに遷移
        if (redirect) {
            navigate(redirect);
            return;
        }
        // https://reactrouter.com/api/hooks/useNavigate#navigate-back-or-forward-in-the-history-stack
        const canGoBack = window.history.length > 2;
        if (canGoBack) {
            navigate(-1);
            return;
        }
        if (isReactNativeWebView()) {
            // WebView内の場合はネイティブアプリに戻る指示を送る
            sendMessageToNativeApp('go_back', { from: 'header' });
        }
    };
    return (
        <div className="header-container">
            {!isBtBack && (
                <div className="back-icon-view" onClick={handleBackButton}>
                    {React.createElement(icBack, { className: 'back-icon' }) ?? 'Back'}
                </div>
            )}
            {!!refetch && (
                <div className="refetch-icon-view" onClick={refetch}>
                    {React.createElement(icRefetch, { className: 'refetch-icon' }) ?? 'Refetch'}
                </div>
            )}
            <h3 style={{ fontWeight: 'bold' }}>{title}</h3>
        </div>
    );
});

Header.prototype = {
    title: PropTypes.string,
    redirect: PropTypes.string,
};

export default Header;
